import React, {  useState } from 'react';
import * as Yup from 'yup';
import {
	Box,
	Button,
} from '@chakra-ui/react'
import { InputText, Form, SelectField } from '../../../components/form'
import { toast } from "react-toastify";
import { fetchWrapper } from '../../../helpers';

function Create({ meClose, loadList, country }) {



	const [formData, setFormData] = useState({
		name: '',
		country_id: '',
		mcc: '',
		mnc: '',
		sms_cost: '',
		whatsapp_cost: '',
		prefix: '',
	});

	const FormSchema = Yup.object().shape({
		name: Yup.string()
		  .required('Operator name is required')
		  .min(2, 'Name must be at least 2 characters')
		  .max(100, 'Name must be less than 100 characters'),
		
		country_id: Yup.string()
		  .required('Country selection is required'),
		
		mcc: Yup.string()
		  .required('MCC is required')
		  .matches(/^\d+$/, 'MCC must contain only numbers')
		  .length(3, 'MCC must be exactly 3 digits'),
		
		mnc: Yup.string()
		  .required('MNC is required')
		  .matches(/^\d+$/, 'MNC must contain only numbers')
		  .min(2, 'MNC must be at least 2 digits')
		  .max(3, 'MNC must be at most 3 digits'),
		
		// sms_cost: Yup.number()
		//   .typeError('SMS cost must be a number')
		//   .required('SMS cost is required')
		//   .min(0, 'SMS cost cannot be negative')
		//   .test('is-decimal', 'SMS cost can have up to 4 decimal places', 
		// 	value => (value + "").match(/^\d+(\.\d{1,4})?$/)),
		
		// whatsapp_cost: Yup.number()
		//   .typeError('WhatsApp cost must be a number')
		//   .required('WhatsApp cost is required')
		//   .min(0, 'WhatsApp cost cannot be negative')
		//   .test('is-decimal', 'WhatsApp cost can have up to 4 decimal places', 
		// 	value => (value + "").match(/^\d+(\.\d{1,4})?$/)),
		
		prefix: Yup.string()
		  .required('Prefix is required')
		  .matches(/^\+?\d+$/, 'Prefix must be a valid phone prefix (numbers with optional + symbol)')
		  .min(1, 'Prefix must have at least 1 digit')
		  .max(5, 'Prefix must be less than 6 digits'),
	  });
	
	 


	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

		let data = values
		const url = `${process.env.REACT_APP_API_URL}/operator/create`;
		await fetchWrapper.post(url, data)
		loadList()
		meClose();
		toast(`Record has been saved `, {
			type: "info"
		});
	}


	return (

		<Form
			enableReinitialize
			validationSchema={FormSchema}
			initialValues={formData}
			onSubmit={onSubmit}
		>
			<Box mb="0px">
				<InputText name="name" title="Operator Name" inputProps={{ isRequired: true }} placeholder="Please Enter Operator Name" />
			</Box>
			<Box mb="0px">
				<SelectField name="country_id" title="Country" list={country} isRequired/>
			</Box>

			<Box mb="0px">
				<InputText name="mcc" title="MCC" inputProps={{ isRequired: true }} placeholder="Please Enter MCC" />
			</Box>
			<Box mb="0px">
				<InputText name="mnc" title="MNC" inputProps={{ isRequired: true }} placeholder="Please Enter MNC" />
			</Box>

			{/* <Box mb="0px">
				<InputText name="sms_cost" title="SMS Cost" inputProps={{ isRequired: true }} placeholder="Please Enter SMS Cost" />
			</Box>
			<Box mb="0px">
				<InputText name="whatsapp_cost" title="Whatsapp Cost" inputProps={{ isRequired: true }} placeholder="Please Enter Whatsapp Cost" />
			</Box> */}
			<Box mb="0px">
				<InputText name="prefix" title="Prefix" inputProps={{ isRequired: true }} placeholder="Please Enter Prefix" />
			</Box>
			<Button py="10px" px="25px" color="#fff" bg="#2563eb" fontSize="14px" fontWeight="500" fontFamily="'Open Sans', sans-serif"
				mb={4}

				type='submit'
			>
				Add New Operator
			</Button>
		</Form>


	)
}

export default Create;